import React from 'react';
import T from 'prop-types';

import { format } from '../../../../utils/date';

const BlogPosts = ({ posts }) => (
  <div className="blog-posts">
    <h2 className="h2 blog-posts-heading">{posts.header_text}</h2>
    <div className="blog-posts-list">
      {posts.resources.map((post, index) => (
        <a key={index} className="blog-post" href={post.url}>
          <div className="img-box">
            <img src={post.preview_image_url} alt={post.title} />
          </div>
          <div className="text-box">
            <p className="text-box-headline">{post.title}</p>
            <p className="text-box-subheadline">{format(post.date, 'MMM. DD, YYYY')} - Apptopia</p>
          </div>
        </a>
      ))}
    </div>
  </div>
);

BlogPosts.propTypes = {
  posts: T.shape({
    header_text: T.string,
    resources: T.array,
  }).isRequired,
};

export default BlogPosts;
